import { render, staticRenderFns } from "./versea.vue?vue&type=template&id=33c08c5c&scoped=true"
import script from "./versea.vue?vue&type=script&lang=js"
export * from "./versea.vue?vue&type=script&lang=js"
import style0 from "./versea.vue?vue&type=style&index=0&id=33c08c5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c08c5c",
  null
  
)

export default component.exports